
import { Box, Button, Typography } from "@mui/material"
import { iconos } from "../../data"




export const DisenioConFuncion = ({ children, titulo ='', handleFuncion=null, disabled=false, padding=0, top=0, scrollY=false }) => {

    
    return (

        <Box sx={{ display:'flex', flexDirection:'column', width:'100%', height:'100%', mt:top,
            backgroundColor:'white', p:padding, minHeight:0, overflowX:'hidden',
            ...(scrollY ? { overflowY: 'auto', overflowX: 'hidden' } : {}),
        }}>

            {/* Header */}
            <Box sx={{ display:'flex', alignItems:'center', mb:3, flexShrink:0 }}>
                <Typography variant="h4">{titulo}</Typography>

                <Box sx={{ flex:1 }} />

                <Button variant="contained" color="secondary" onClick={ handleFuncion }
                    sx={{ color: '#fff', ':hover': { opacity: 0.5 }, py: 1 }} disabled={disabled}
                >
                    { iconos['plus'] }
                </Button>
            </Box>


            {/* Contenido */}
            <Box sx={{ flex:1, display:'flex', flexDirection:'column' }}>
                {children}
            </Box>
        </Box>

    )
}
